import View from "./view";
import CreatePresenter from "./create.presenter";
import EditPresenter from "./edit.presenter";
import { ConnectComponent } from "util";

const states = [
  {
    name: "app.registration.product.create",
    url: "/novo",
    views: {
      "content@app": ConnectComponent(View, CreatePresenter)
    }
  },
  {
    name: "app.registration.product.edit",
    url: "/:productUuid/editar",
    views: {
      "content@app": ConnectComponent(View, EditPresenter)
    }
  }
];

export { states };



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/index.js